<div class="modal is-active">
  <div class="modal-background" (click)="onClose.emit()"></div>
  <div class="modal-card" style="width: 90vw">
    <header class="modal-card-head">
      <p class="modal-card-title m-0" translationEditableDirective="PREVIEW">
        {{ 'PREVIEW' | translate }}
      </p>
      <button
        class="delete"
        (click)="onClose.emit()"
        aria-label="close"
      ></button>
    </header>
    <section class="modal-card-body">
      <div class="layer-wrapper">
        <div id="ol-layer" class="ol-map"></div>
        <div
          #olPopup
          class="ol-popup"
          [ngClass]="{ 'is-open': isPopupVisible }"
        >
          <a href="#" class="ol-popup-closer"></a>
          <div class="ol-popup-content">
            <div>
              <b>{{ 'LABEL' | translate }}</b
              >:
              <span>{{ popupData.label || '-' }}</span>
            </div>
            <div>
              <b>{{ 'VALUE' | translate }}</b
              >:
              <span>{{ popupData.value || '-' }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
